import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dd7550c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "about-detail"
}
const _hoisted_2 = {
  key: 0,
  class: "header-content",
  style: {"margin-bottom":"10px"}
}
const _hoisted_3 = {
  class: "header",
  style: {"border-bottom":"none"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "表头内容", -1))
const _hoisted_5 = {
  key: 0,
  style: {"color":"#959FAC"}
}
const _hoisted_6 = {
  key: 1,
  class: "header-content"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "检查项目", -1))
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "subtitle" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "norm-title" }
const _hoisted_13 = {
  key: 0,
  class: "state"
}
const _hoisted_14 = {
  key: 1,
  class: "state"
}
const _hoisted_15 = {
  key: 0,
  class: "score2"
}
const _hoisted_16 = {
  key: 1,
  class: "score4"
}
const _hoisted_17 = {
  key: 0,
  class: "norm-image"
}
const _hoisted_18 = ["src", "onClick"]
const _hoisted_19 = {
  key: 1,
  class: "norm-problem"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "存在问题：", -1))
const _hoisted_21 = {
  key: 2,
  class: "norm-desc"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "备注：", -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "整改单：", -1))
const _hoisted_25 = { class: "orderid" }
const _hoisted_26 = { class: "footer" }
const _hoisted_27 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailInfo = _resolveComponent("DetailInfo")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_tree_select = _resolveComponent("van-tree-select")!

  return (_ctx.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_DetailInfo, {
          detail: _ctx.detail,
          style: {"margin-bottom":"10px"}
        }, null, 8, ["detail"]),
        (_ctx.detail.thead_state != '0')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                (_ctx.detail.thead_state == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "未填写"))
                  : _createCommentVNode("", true),
                (_ctx.detail.thead_state == 2)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.$router.push({
              name: _ctx.$RouterName.QUALITY_POOL_DETAIL,
              query: {
                id: _ctx.$route.query.id,
                recheck_num: _ctx.detail.recheck_num
              }
            })
          ))
                    }, [
                      _createTextVNode("已填写"),
                      _createVNode(_component_van_icon, {
                        name: "arrow",
                        color: "#959FAC"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.currentSelect)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createVNode(_component_van_tree_select, {
                  height: "auto",
                  items: _ctx.selectList,
                  onClickNav: _ctx.clickNav,
                  "main-active-index": _ctx.activeIndex,
                  "onUpdate:mainActiveIndex": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeIndex) = $event))
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.currentSelect.item_name), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", null, " 检查人：" + _toDisplayString(_ctx.currentSelect.handler_user_info.name || "-"), 1),
                        (_ctx.detail.temp_check_config.includes('4'))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "得分 (" + _toDisplayString(Number(_ctx.currentSelect.score) - Number(_ctx.currentSelect.bad_score)) + "/" + _toDisplayString(_ctx.currentSelect.score) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSelect.norm_lists, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "norm-item",
                          key: item.id
                        }, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(index + 1) + " " + _toDisplayString(item.title), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(['norm-state', `norm-state${item.result || '4'}`])
                          }, [
                            (item.result)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.result == "1" ? "合格" : item.result == "2" ? "不合格" : "不涉及"), 1))
                              : _createCommentVNode("", true),
                            (!item.result)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, "未检查"))
                              : _createCommentVNode("", true),
                            (_ctx.detail.temp_check_config.includes('4'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (item.result == '2' && Number(item.score))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "分值 " + _toDisplayString(item.score), 1))
                                    : _createCommentVNode("", true),
                                  (!item.result)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "分值 " + _toDisplayString(item.score), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 2),
                          (item.pic_arr && item.pic_arr.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pic_arr, (i, idx) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    src: i.photo_thumb_file,
                                    key: i.id,
                                    onClick: ($event: any) => (_ctx.clickImage(idx, item.pic_arr))
                                  }, null, 8, _hoisted_18))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (item.problem)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _hoisted_20,
                                _createTextVNode(" " + _toDisplayString(item.problem), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.desc)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _hoisted_22,
                                _createTextVNode(" " + _toDisplayString(item.desc), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (item.reform_id)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                class: "norm-reform",
                                onClick: ($event: any) => (
                    _ctx.$router.push({
                      name: _ctx.$RouterName.QUALITY_RECTIFICATION_DETAIL,
                      query: { id: item.reform_id }
                    })
                  )
                              }, [
                                _hoisted_24,
                                _createElementVNode("span", _hoisted_25, _toDisplayString(item.reform_orderid), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(`state${item.reform_state}`)
                                }, _toDisplayString(item.reform_state_name), 3)
                              ], 8, _hoisted_23))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["items", "onClickNav", "main-active-index"])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", null, [
                  _createTextVNode(" 不合格："),
                  _createElementVNode("i", null, _toDisplayString(_ctx.detail.total_bad_norm_num), 1),
                  _createElementVNode("span", null, "/" + _toDisplayString(_ctx.detail.total_norm_num), 1)
                ]),
                (_ctx.detail.temp_check_config.includes('4'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createTextVNode(" 考评分数: "),
                      _createElementVNode("span", null, _toDisplayString(_ctx.detail.total_score), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}